import './common.scss';
import './App.css';
import { ToastContainer } from "react-toastify";
import Navbar from './routes/Navbar/Navbar';
import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import Login from './routes/Login/Login';
import Dashboard from './routes/Dashboard/Dashboard';
import MyOrders from './routes/MyOrders/MyOrders';
import Profile from './routes/Profile/Profile';
import Privacy from './routes/Privacy';
import Terms from './routes/Terms';
import ResetPassword from "./routes/ResetPassword/ResetPassword";
import RFQDetails from './routes/RFQDetails/RFQDetails';
import OrderDetails from './routes/OrderDetails/OrderDetails';
import Maintanence from './component/Maintanence';
import { useEffect } from 'react';
import qs from 'query-string';
import PrivateRoute from './routes/PrivateRoute';
import { firebaseSignOnLoginSuccess } from './utils/firebase';
import jwt_decode from 'jwt-decode';
import OfferDetails from './routes/OfferDetails/OfferDetails';
import OfferEdit from './routes/OfferDetails/OfferEdit';
import { getUserCurrencyFromLocalStorage, getUserIdFromLocalStorage } from './utils/helper';
import { getSupplierDataByUserId } from './utils/actions/userActions';



function App() {
  let loggedIn = localStorage.getItem('isLoggedIn');
  let token = localStorage.getItem('Token');
  const location = useLocation();

  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.removeItem("Token");
    localStorage.removeItem("_id");
    localStorage.removeItem("firstName");
    localStorage.removeItem("lastName");
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("email");
    localStorage.removeItem("pathAfterLogin");
    navigate('/', { state: { from: location.pathname } });
  };

  // useEffect(() => {
  //   token = localStorage.getItem('Token');
  //   const isLoggedIn = localStorage.getItem("isLoggedIn");
  //   if (!token) {
  //     if (!(location.pathname.includes('verifyEmail'))) {
  //       handleLogout();
  //       return;
  //     }
  //   } else {
  //     let decode = jwt_decode(token);
  //     if ((decode.exp * 1000) < Date.now()) {
  //       handleLogout();
  //     }
  //     if ((decode.exp * 1000) - Date.now() < 1800) {
  //       handleLogout();
  //     }
  //   }

  //   if (isLoggedIn != 'true' && !(location.pathname.includes('verifyEmail'))) {
  //     handleLogout();
  //   }
  //   firebaseSignOnLoginSuccess();
  //   const { search, } = window.location;
  //   const param = qs.parse(search);
  //   if (param.redirected_url && token) {
  //     window.href = param.redirected_url + search;
  //   };
  // }, [])

  useEffect(() => {
    (async () => {
      try {
        const id = getUserIdFromLocalStorage();
        const isCurrencyExists = getUserCurrencyFromLocalStorage();
        if (!isCurrencyExists && id) {
          //fetch currency details
          const res = await getSupplierDataByUserId(id);
          if (res.success) {
            const { data } = res;
            const { currency } = data;
            const currencyMeta = {
              code: currency,
              precision: 2,
            }
            localStorage.setItem('currency_meta', JSON.stringify(currencyMeta));
          }
        }

      } catch (error) {
        console.error('Failed to load user currency');
      }
    })();

  }, []);








  return (
    <div className="App ">
      <ToastContainer />
      <Routes>
        {process.env.REACT_APP_IN_MAINTANANCE == 'true' ?
          <>
            <Route path='/*' element={<Maintanence />} />
          </>
          :
          <>
            <Route path='/' element={loggedIn && token ? <Navigate to='/dashboard' /> : <Login />} />
            <Route path='/login' element={loggedIn && token ? <Navigate to='/dashboard' /> : <Login />} />
            <Route path="/:id/verifyEmail/" element={<ResetPassword />}></Route>

            <Route path="/privacy-policy" element={<Privacy />}></Route>
            <Route path="/terms-of-service" element={<Terms />}></Route>
            <Route path='/' element={<Navbar />}>

              <Route path='/dashboard' element={<PrivateRoute />}>
                <Route path='/dashboard' element={<Dashboard />} />
              </Route>
              <Route path='/my-orders' element={<PrivateRoute />}>
                <Route path='/my-orders' element={<MyOrders />} />
              </Route>

              <Route path='/profile' element={<PrivateRoute />}>
                <Route path='/profile' element={<Profile />} />
              </Route>
              <Route path='/rfq-details/:id' element={<PrivateRoute />}>
                <Route path="/rfq-details/:id" element={<RFQDetails />} />
              </Route>
              <Route path='/offer-details/:id' element={<PrivateRoute />}>
                <Route path="/offer-details/:id" element={<OfferDetails />} />
              </Route>

              <Route path='/offer-details/:id' element={<PrivateRoute />}>
                <Route path="/offer-details/:id" element={<OfferDetails />} />
              </Route>

              <Route path='/offer-edit/:id' element={<PrivateRoute />}>
                <Route path="/offer-edit/:id" element={<OfferEdit />} />
              </Route>
              <Route path='/order-details/:id' element={<PrivateRoute />}>
                <Route path="/order-details/:id" element={<OrderDetails />} />
              </Route>
            </Route>
          </>
        }

      </Routes>
    </div>
  );
}

export default App;
